// src/app/shared/directives/track-click.directive.ts
import { Directive, HostListener, Input } from '@angular/core';
import { MixpanelService } from '../service/mix-panel.service';
import { MixpanelEvent } from '../model/mix-panel-event.enum';



@Directive({
  selector: '[appTrackClick]'
})
export class TrackClickDirective {
  @Input() buttonProps !:{
          title?:string,
          customeId?:string,
          feature_context?: 'HITMAKER' | 'CINEJOY'|'HOME'|string}
           

  constructor(private mixpanelService: MixpanelService) {}

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent) {
    this.mixpanelService.trackEvent({
        event:  MixpanelEvent.BUTTON_CLICKED,
        properties:this.buttonProps
    });
  }
}